import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import store from "./App/store/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import App from "./App/App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

let persistor = persistStore(store);

// eslint-disable-next-line no-undef
const baseURL = process.env.PUBLIC_URL;

root.render(
	// <React.StrictMode>
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter basename={baseURL}>
				<App />
			</BrowserRouter>
		</PersistGate>
	</Provider>,
	// </React.StrictMode>,
);
